/* eslint-disable eqeqeq */
import { EventDispatcher, addFilteredEventListener, addZero, fadeIn, fadeOut, getNodeIndex, getTimeText, isDesktopView, l, lc, qs, qsa } from '@utils/toolbox';
import { resultsRender } from '@components/resultsRender';
import { dateParseISO, dateShortWeekDaysArray } from '@utils/dateFns';

/* eslint-disable camelcase */
export const timeline = {
	active: false,
	cachedDates: {},
	canvasShift: 75,
	currentBoundIndex: 0,
	currentFlightIndex: null,
	emailData: {},
	elems: {
		timelinePrimary: qs('#main-timeline'),
		timelineSecondary: qs('#secondary-timeline'),
		timelineSecondaryInner: qs('.secondary-timeline-inner')
	},
	filterMouseEnterScrollTop: null,
	isTwoLegsTrip: js_params.trips_count == 2,
	openingResultModal: false,
	popup: [],
	previousClick: null,
	resultData: null,
	selectedItem: null,
	sorting: {
		helpers: {
			departureDate (a, b) {
				const a_date = timeline.cachedDate(a[0].alternative.segments[0].departureDate);
				const b_date = timeline.cachedDate(b[0].alternative.segments[0].departureDate);

				return a_date - b_date;
			},

			arrivalDate (a, b) {
				const a_date = timeline.cachedDate(a[0].alternative.segments[0].arrivalDate);
				const b_date = timeline.cachedDate(b[0].alternative.segments[0].arrivalDate);

				return a_date - b_date;
			},

			price (a, b) {
				const aLowest = timeline.sorting.lowestPrice(a);
				const bLowest = timeline.sorting.lowestPrice(b);

				return aLowest - bLowest;
			},

			traveltime (a, b) {
				return a[0].alternative.traveltime - b[0].alternative.traveltime;
			}
		},

		lowestPrice (items) {
			let lowest = Number.MAX_VALUE;

			for (let j = 0; j < items.length; ++j) {
				const item = items[j];

				for (let i = 0; i < item.flight.agents.length; ++i) {
					if (item.flight.agents[i].price < lowest) {
						lowest = item.flight.agents[i].price;
					}
				}
			}

			return lowest;
		},

		sort: {
			arrivalDate (a, b) {
				let diff = timeline.sorting.helpers.arrivalDate(a, b);

				if (diff == 0) {
					diff = timeline.sorting.helpers.price(a, b);
				}

				return diff;
			},

			departureDate (a, b) {
				let diff = timeline.sorting.helpers.departureDate(a, b);

				if (diff == 0) {
					diff = timeline.sorting.helpers.price(a, b);
				}

				return diff;
			},

			bestValue (a, b) {
				const minPrice = resultsRender.response.uniquePrices[0];
				const minTraveltime = resultsRender.response.uniqueTraveltimes[0];

				const priceA = timeline.sorting.lowestPrice(a) / minPrice;
				const priceB = timeline.sorting.lowestPrice(b) / minPrice;

				const traveltimeA = a[0].alternative.traveltime / minTraveltime;
				const traveltimeB = b[0].alternative.traveltime / minTraveltime;

				const resultA = priceA * 0.5 + traveltimeA * 0.5;
				const resultB = priceB * 0.5 + traveltimeB * 0.5;

				const result = resultA - resultB;

				return result;
			},

			price (a, b) {
				let diff = timeline.sorting.helpers.price(a, b);

				if (diff == 0) {
					diff = timeline.sorting.helpers.traveltime(a, b);
				}

				return diff;
			},

			traveltime (a, b) {
				let diff = timeline.sorting.helpers.traveltime(a, b);

				if (diff == 0) {
					diff = timeline.sorting.helpers.price(a, b);
				}

				return diff;
			}
		}
	},

	timeouts: {
		airlineHover: null
	},

	alternativeHash (alternative) {
		const sum = [];

		for (let i = 0; i < alternative.segments.length; ++i) {
			const segment = alternative.segments[i];
			const str = segment.departureAirport + segment.arrivalAirport + segment.departureDate + segment.arrivalDate;

			sum.push(str);
		}

		return sum.join('');
	},

	cachedDate (date) {
		if (!this.cachedDates[date]) {
			this.cachedDates[date] = dateParseISO(date).getTime();
		}
		return this.cachedDates[date];
	},

	closeSelected () {
		if (!timeline.previousClick) {
			return;
		}

		qs('#main-timeline div.pointer').remove();
		fadeOut(this.elems.timelineSecondary);
		document.body.classList.remove('modal-open');

		timeline.previousClick.a.style.marginBottom = 0;
		timeline.previousClick.flight.style.marginBottom = 0;
		timeline.previousClick.a.style.marginBottom = 0;
		timeline.previousClick.flight.style.marginBottom = 0;
		timeline.previousClick.a.classList.remove('border-at-selection');
		timeline.previousClick.a.classList.remove('active');
		timeline.elems.timelineSecondaryInner.scrollTo(0, 0);

		timeline.previousClick.flight.classList.remove('border-at-selection');
		timeline.previousClick.borderA?.classList?.remove?.('border-after-selection');
		timeline.previousClick.borderDiv?.classList.remove('border-after-selection');
		timeline.previousClick.timeline.classList.remove('state-selection');

		// Reset selection state
		timeline.previousClick = null;
		timeline.selectedItem = null;
		timeline.currentBoundIndex = 0;
	},

	findPrices (opts) {
		const hashes = Array.isArray(opts.hashes) ? opts.hashes : [opts.hashes];
		timeline.currentFlightIndex = opts.index;

		// Ask Showresult to update the results accordingly
		EventDispatcher.dispatch('updateResults', { params: { page: 0, filters: { alternativeHashes: hashes } }, source: 'timeline' });
	},

	flightForAnchor (element) {
		const prices = element.closest('.timeline-data-canvas-prices-price');
		const index = getNodeIndex(prices);

		const flights = element.closest('.showresult-timeline').querySelectorAll('.timeline-data-canvas .timeline-data-canvas-cells-rows-row');

		return flights[index];
	},

	getBounds (min, max, forced_increment) {
		const dateMin = new Date(min);
		let dateMax = new Date(max);

		dateMin.setMinutes(0);
		dateMin.setSeconds(0);

		dateMax.setMinutes(60);
		dateMax.setSeconds(0);

		const hourspan = (dateMax.getTime() - dateMin.getTime()) / (3600 * 1000);
		let sections = 7;
		let scale_ceil = Math.ceil(hourspan / sections);

		if (scale_ceil > 6 || forced_increment) {
			scale_ceil = forced_increment ? forced_increment : 6;
			sections = Math.ceil(hourspan / scale_ceil);
			sections = sections < 7 ? 7 : sections;
		}

		dateMax = new Date(dateMin.getTime() + sections * 1000 * 3600 * scale_ceil);

		return { increment: scale_ceil, max: dateMax.getTime(), min: dateMin.getTime(), sections: sections };
	},

	getDataAndFilter (groups, index) {
		let minDate = Number.MAX_VALUE;
		let maxDate = Number.MIN_VALUE;

		const results = [];

		for (let i = 0; i < groups.length; ++i) {
			const flight = groups[i];
			const addFlight = true;

			flight.trips = resultsRender.getTripsAndSegmentsForFlight(flight, index);

			const trip = flight.trips[index];

			for (let k = 0; k < trip.segments.length; ++k) {
				const seg = trip.segments[k];

				const dateDep = timeline.cachedDate(seg.departureDate);
				const dateArr = timeline.cachedDate(seg.arrivalDate);

				if (dateDep < minDate) {
					minDate = dateDep;
				}

				if (dateArr > maxDate) {
					maxDate = dateArr;
				}
			}

			if (addFlight) {
				results.push(flight);
			}
		}

		return { filtered: results, max: maxDate, min: minDate };
	},

	getDepartureName (data) {
		try {
			const airport = data[0][0].alternative.segments[0].departureAirport;
			return timeline.currentData.data.airportDetails[airport].city;
		} catch (e) {
			try {
				console.log('departure airport failed');
			} catch (e) {
				window.onerror(e.toString(), '?', 0, 0);
			}
		}

		return '';
	},

	getDestinationName (data) {
		try {
			const segments = data[0][0].alternative.segments;
			const lastSegment = segments[segments.length - 1];
			const arrivalAirport = lastSegment.arrivalAirport;

			return timeline.currentData.data.airportDetails[arrivalAirport].city;
		} catch (e) {
			try {
				console.log('destination airport failed');
			} catch (e) {
				window.onerror(e.toString(), '?', 0, 0);
			}
		}

		return '';
	},

	hide () {
		this.active = false;

		const clickable = qs('#filters-column .clickable');
		if (clickable) {
			clickable.cursor = 'auto';
		}

		fadeOut(this.elems.timelineSecondary);

		EventDispatcher.dispatch('showResultDisplay:reset');
	},

	getTimeAndWeekday (timeMilliseconds) {
		const time = new Date(timeMilliseconds);
		return addZero(time.getHours()) + ':' + addZero(time.getMinutes()) + ' <span class="weekday">(' + dateShortWeekDaysArray[time.getDay()] + ')</span>';
	},

	removePopup () {
		const popup = this.popup;

		if (popup.length) {
			const prevPopup = popup[popup.length - 1];

			prevPopup.style.opacity = 0;

			setTimeout(() => document.body.removeChild(prevPopup), 200);
			popup.pop();
		}
	},

	render (data) {
		const tripIndex = data.tripIndex;

		if (data.rows.length == 0) {
			const prices = qs('.timeline-data-canvas-prices', data.selector);
			if (prices) {
				prices.innerHTML = '';
			}
			const rows = qs('.timeline-data-canvas-cells-rows', data.selector);
			if (rows) {
				rows.innerHTML = '';
			}
			return;
		}

		// render header times

		const bounds = data.bounds;

		const cityDest = tripIndex == 0 ? js_params.to.city : js_params.from.city;
		const cityDeparture = tripIndex == 0 ? js_params.from.city : js_params.to.city;

		let departDate = new Date(js_params.leavedate);
		const departDateDay = departDate.getDate();
		const departDateMonth = js_params.monthsLong[departDate.getMonth()];
		const departDateYear = departDate.getFullYear();

		departDate = ', ' + departDateDay + ' ' + departDateMonth + ' ' + departDateYear;

		const depdest = qsa('.timeline-data-canvas-iatas .timeline-data-canvas-iatas-iata', data.selector);
		depdest[0].innerText = cityDeparture;
		depdest[depdest.length - 1].innerText = cityDest;

		qs('.timeline-data-canvas-header .timeline-data-canvas-header-title-text-small', this.elems.timelinePrimary)
			.innerHTML = js_params.from.city + ' - ' + js_params.to.city + '<span class="date">' + departDate + '</span>';

		const times_html = [];
		let lines_html = '';

		const columnLeftPosition = 1 * (100 / bounds.sections);

		for (let i = 0; i <= bounds.sections; ++i) {
			const time = bounds.min + 3600 * 1000 * i * bounds.increment;
			const depTime = timeline.getTimeAndWeekday(time);
			const arrTime = timeline.getTimeAndWeekday(time);
			const left = (columnLeftPosition * i) + '%';

			times_html.push(
			`<div class="timeline-data-canvas-times-time" style="left:${left}">
				<span class="timeline-data-canvas-times-time-label local">${depTime}</span>
				<span class="timeline-data-canvas-times-time-label destination">${arrTime}</span>
			</div>`);

			lines_html += '<div class="timeline-data-canvas-cells-cols-col" style="left:' + left + '"></div>';
		}

		qs('.timeline-data-canvas-times', data.selector).innerHTML = times_html.join('');

		// draw column lines
		qs('.timeline-data-canvas-cells-cols > .timeline-data-canvas-cells-cols-col', data.selector).remove();
		setTimeout(function () {
			qs('.timeline-data-canvas-cells-cols', data.selector).insertAdjacentHTML('beforeend', lines_html);
		}, 1);

		// flights

		const time_span = bounds.max - bounds.min;
		const prices_html = [];
		const row_html = [];
		let row_html_bar = [];
		let offset = 0;
		let totalWidth = 0;

		for (let i = 0; i < data.rows.length; ++i) {
			const item = data.rows[i];
			const price = item.agents[0].price;
			const alternative = item.trips[tripIndex];
			const journeyTime = getTimeText(alternative.traveltime);

			prices_html.push(
			`<a href="#" class="timeline-data-canvas-prices-price">
				<span class="timeline-data-canvas-prices-price-label price">${lc(price, true)}</span>
				<span class="timeline-data-canvas-prices-price-btn">
					<span class="default-state">${l('showresult.timeline.chooseDeparture')}</span>
					<span class="active-state">${l('showresult.timeline.changeDeparture')}</span>
				</span>
			</a>`);

			let airportDate = null;
			let airport = null;
			const row_html_saved = [];
			const row_width_saved = [];

			for (let j = 0; j < alternative.segments.length; ++j) {
				const seg = alternative.segments[j];

				const departureDate = timeline.cachedDate(seg.departureDate);
				const arrivalDate = timeline.cachedDate(seg.arrivalDate);

				let airlineCode = '';

				try {
					airlineCode = seg.flight.substr(0, 2);
				} catch (e) {
					window.onerror(e.toString(), '?', 0, 0);
				}

				const width = (arrivalDate - departureDate) / time_span * 1000;
				totalWidth += width;

				if (j == 0) {
					offset = (departureDate - bounds.min) / time_span * 100;

					row_width_saved.push(width);
					row_html_saved.push(
					`<div class="timeline-data-canvas-cells-rows-row-bar-section airline" title="${airlineCode}" style="width: _PERCENTAGE_%;">
						<span class="icon icon-plane-up"></span>
					</div>`);
				} else {
					if (airportDate && airport) {
						const airport_width = (departureDate - airportDate) / time_span * 1000;
						const airport2 = seg.departureAirport;
						const airports_differ = airport != airport2;

						totalWidth += airport_width;

						if (airports_differ) {
							row_width_saved.push(airport_width);
							row_html_saved.push(
							`<div class="timeline-data-canvas-cells-rows-row-bar-section connection" style="width:_PERCENTAGE_%;">
								<span class="combined"><span class="hidden">${airport}</span></span>
								<div class="spacer"></div>
								<span class="combined"><span class="hidden">${airport2}</span></span>
							</div>`);
						} else {
							row_width_saved.push(airport_width);
							row_html_saved.push(`<div class="timeline-data-canvas-cells-rows-row-bar-section connection" style="width:_PERCENTAGE_%;"><span class="hidden">${airport}</span></div>`);
						}
					}

					row_width_saved.push(width);
					row_html_saved.push(
					`<div class="timeline-data-canvas-cells-rows-row-bar-section airline" title="${airlineCode}" style="width:_PERCENTAGE_%;">
						<span class="icon icon-plane-down"></span>
					</div>`);
				}

				airportDate = arrivalDate;
				airport = seg.arrivalAirport;
			}

			row_html_bar.push(
			`<div class="timeline-data-canvas-cells-rows-row-bar-timespan">
				<div class="timeline-data-canvas-cells-rows-row-bar-timespan-text">
					<span>${journeyTime}</span>
				</div>
			</div>`);

			totalWidth = (totalWidth / 100) * 10;

			for (let s = 0; s < row_width_saved.length; ++s) {
				// var replaceHtml = row_html_saved[s].replace('_PERCENTAGE_', Math.floor((row_width_saved[s] / totalWidth) * 10));
				const replaceHtml = row_html_saved[s].replace('_PERCENTAGE_', (row_width_saved[s] / totalWidth) * 10);

				row_html_bar.push(replaceHtml);
			}

			row_html.push(
			`<div class="timeline-data-canvas-cells-rows-row">
				<div class="timeline-data-canvas-cells-rows-row-bar" style="width: ${totalWidth}%; margin-left: ${offset}%;">
				${row_html_bar.join('')}
				</div>
			</div>`);

			totalWidth = 0;
			row_html_bar = [];
		}

		qs('.timeline-data-canvas-prices', data.selector).innerHTML = prices_html.join('');
		qs('.timeline-data-canvas-cells-rows', data.selector).innerHTML = row_html.join('');
	},

	renderPopup (params) {
		const { html, position } = params;
		const popup = document.createElement('div');

		popup.setAttribute('class', 'timeline-flight-info-popup');
		popup.innerHTML = html;

		document.body.appendChild(popup);

		position.left -= popup.offsetWidth / 2;
		position.left = position.left < 0 ? 0 : position.left;

		popup.style.left = position.left + 'px';
		popup.style.top = position.top + 'px';
		popup.style.opacity = 1;

		return popup;
	},

	renderResultModal (flight, index) {
		timeline.currentFlight = flight;

		resultsRender
			.renderModal(
				js_params.id,
				flight,
				index,
				resultsRender.searchParams.filters,
				{
					className: 'modal--resultModal',
					footer:
					`<button class="js-close-modal abBtn abBtn--blueWhite abBtn--flex">
						<span>${l('global.simplePhrases.close')}</span>
					</button>`,
					hideHeader: true,
					hideOnSwipe: true,
					id: 'timelineResultModal',
					onClose: () => {
						resultsRender.resultModal = null;
						timeline.currentFlightIndex = null;
						timeline.openingResultModal = false;
						if (!timeline.isTwoLegsTrip) {
							timeline.selectedItem = null;
							timeline.currentBoundIndex = 0;
						}
					},
					resetScroll: true
				},
				{},
				'timeline'
			)
			.open();
	},

	renderSecondary (item) {
		const hash = item.trips[0].hash;
		timeline.currentBoundIndex = 1;

		// Ask Showresult to update the results accordingly
		EventDispatcher.dispatch('updateResults', { params: { page: 0, groupBy: { index: 1 }, filters: { alternativeHashes: [hash] } }, source: 'timeline' });
	},

	show () {
		this.active = true;
		EventDispatcher.dispatch('showResultDisplay:show', { display: 'timeline' });
	},

	init () {
		const self = this;

		// Initiate result update request params on showresult demand
		EventDispatcher.addEventListener('showresult:requestResultUpdate', (data) => {
			if (!this.active || data.target !== 'timeline') {
				return;
			}
			this.update();
		});

		// Show/hide timetable based on showresult view changes
		EventDispatcher.addEventListener('displayDirector:display', ({ display }) => {
			if (display === 'timeline') {
				this.show();
				this.update();
			} else {
				this.hide();
			}
		});

		// Hide results if there was an error
		EventDispatcher.addEventListener('showresult:requestResultUpdateError', ({ target }) => {
			if (target === 'timeline') {
				this.hide();
			}
		});

		// Render new results when results have been updated from showresult (mostly due to filters update)
		EventDispatcher.addEventListener('showresult:resultsUpdated', (flights) => {
			if (!timeline.active) {
				return;
			}

			if (!flights.length) {
				fadeOut(this.elems.timelinePrimary);
				this.closeSelected();
				return;
			} else {
				fadeIn(this.elems.timelinePrimary);
			}

			const boundIndex = timeline.currentBoundIndex;
			const data = timeline.getDataAndFilter(flights, boundIndex);
			const bounds = timeline.getBounds(data.min, data.max);

			if (!this.selectedItem || (boundIndex === 0 && this.isTwoLegsTrip)) {
				// Render the main timelines (first bound)
				timeline.bounds = [bounds];
				timeline.resultData = data.filtered;

				timeline.render({
					bounds: bounds,
					rows: data.filtered,
					selector: this.elems.timelinePrimary,
					tripIndex: boundIndex
				});
			} else {
				if (timeline.currentFlightIndex !== null || !this.isTwoLegsTrip) {
					// Show trip details render
					timeline.openingResultModal = true;
					timeline.renderResultModal(flights[0], timeline.currentFlightIndex);
				} else {
					// Second leg trip render updates
					timeline.resultDataOther = flights;

					fadeIn(this.elems.timelineSecondary);
					timeline.render({
						bounds: bounds,
						rows: flights,
						selector: this.elems.timelineSecondary,
						tripIndex: boundIndex
					});

					// Position the secondary timelines
					if (!isDesktopView()) {
						document.body.classList.add('modal-open');
					} else {
						const height = this.elems.timelineSecondary.clientHeight;
						timeline.previousClick.a.style.marginBottom = height + 25 + 'px';
						timeline.previousClick.flight.style.marginBottom = height + 25 + 'px';

						window.scrollTo({
							behavior: 'smooth',
							top: qs('.timeline-data-canvas-cells-rows-row.border-at-selection').getBoundingClientRect().top + window.scrollY
						});
					}
				}
			}
		});

		// show inbound flights
		this.elems.timelinePrimary.addEventListener('click', (e) => {
			const target = e.target.closest('.timeline-data-canvas-cells-rows-row-bar');
			if (!target) {
				return;
			}

			if (timeline.openingResultModal) {
				return;
			}

			e.stopPropagation();

			const canvas = target.closest('.timeline-data-canvas-cells');
			const timelineMain = canvas.closest('#main-timeline');
			const secondaryTimeline = this.elems.timelineSecondary;

			timelineMain.classList.add('state-selection');

			const flight = target.closest('.timeline-data-canvas-cells-rows-row');
			const index = getNodeIndex(flight);

			const anchorTag = timelineMain.querySelectorAll('.timeline-data-canvas-prices-price')[index];

			const item = timeline.resultData[index];

			timeline.closeSelected();
			timeline.selectedItem = item;

			if (timeline.isTwoLegsTrip) {
				const prev = timeline.previousClick;

				if (prev && prev.index == index) {
					return;
				}

				fadeIn(this.elems.timelineSecondary);

				flight.classList.add('border-at-selection');
				anchorTag.classList.add('border-at-selection');

				const borderDiv = canvas.querySelectorAll('.timeline-data-canvas-cells-rows-row')[index + 1];
				borderDiv?.classList.add('border-after-selection');

				const borderA = qs('#main-timeline .timeline-data-canvas-prices').querySelectorAll('.timeline-data-canvas-prices-price')[index + 1];
				anchorTag.classList.add('border-after-selection');


				if (isDesktopView()) {
					let timelineTopHeight = qs('#secondary-timeline .timeline-data-canvas-header').offsetHeight;
					timelineTopHeight += qs('#secondary-timeline .timeline-data-canvas-times').offsetHeight;
					timelineTopHeight += 7;

					const rowHeight = qs('.showresult-timeline .timeline-data-canvas .timeline-data-canvas-cells-rows-row').offsetHeight;
					const offset = this.elems.timelinePrimary.getBoundingClientRect().top - qs('#results-wrapper').getBoundingClientRect().top
					+ timelineTopHeight + rowHeight * (index + 1);

					secondaryTimeline.style.top = offset + 'px';
				}

				timeline.renderSecondary(item);

				target.insertAdjacentHTML('beforeend', '<div class="pointer"></div>');

				const tripSegs = timeline.selectedItem.trips[0].segments;

				let returnDate;
				const departDate = qs('#main-timeline .timeline-data-canvas-header-title-text-small span.date').innerText;

				if (tripSegs.length === 1) {
					// is single flight - no connections
					returnDate = new Date(tripSegs[0].arrivalDate.substr(0, 10));
				} else {
					// has at-least 1 connection
					returnDate = new Date(js_params.homedate);
				}

				const returnDateDay = returnDate.getDate();
				const returnDateMonth = js_params.monthsLong[returnDate.getMonth()];
				const returnDateYear = returnDate.getFullYear();

				returnDate = ', ' + returnDateDay + ' ' + returnDateMonth + ' ' + returnDateYear;

				const headerTitleSmall = secondaryTimeline.querySelectorAll('.timeline-data-canvas-header-title-text-small');

				headerTitleSmall[0].innerHTML = js_params.from.city + ' - ' + js_params.to.city + departDate;

				headerTitleSmall[headerTitleSmall.length - 1].innerHTML = js_params.to.city + ' - ' + js_params.from.city + returnDate;


				timeline.previousClick = {
					a: anchorTag,
					borderA: borderA,
					borderDiv: borderDiv,
					flight: flight,
					index: index,
					timeline: timelineMain
				};

				if (!isDesktopView()) {
					window.scrollTo(0, 0);
				}
			} else {
				const hashes = timeline.selectedItem.trips[0].hash;

				timeline.findPrices({
					hashes: hashes,
					index: index
				});
			}

			return false;
		});

		// when clicking price to the left
		addFilteredEventListener('.showresult-timeline', 'click', '.timeline-data-canvas-prices-price', ({ closest }) => {
			qsa('.showresult-timeline .timeline-data-canvas-prices-price.active').forEach((element) => {
				element.classList.remove('active');
			});

			const flight = timeline.flightForAnchor(closest);
			flight.click();
			closest.classList.add('active');
		});

		qs('.showresult-timeline').addEventListener('click', function (e) {
			if (e.target.matches('.timeline-data-canvas-cells-rows-row')) {
				qs('span', e.target).click();
			}
			// return false;
		});

		// Bring up popup with agencies for chosen flights

		this.elems.timelineSecondary.addEventListener('click', function (e) {
			const target = e.target.closest('.timeline-data-canvas-cells-rows-row-bar');
			if (!target) {
				return;
			}


			e.stopPropagation();
			if (timeline.openingResultModal) {
				return;
			}

			// const canvas = target.closest('.timeline-data-canvas');
			const flight = target.closest('.timeline-data-canvas-cells-rows-row');
			const index = getNodeIndex(flight);
			const item = timeline.resultDataOther[index];

			const hashes = [timeline.selectedItem.trips[0].hash, item.trips[1].hash];
			timeline.findPrices({
				hashes: hashes,
				index: index
			});
		});

		// close button
		this.elems.timelineSecondary.addEventListener('click', function (e) {
			const targetCloseButton = e.target.closest('.timeline-data-canvas-header .close-btn');
			if (targetCloseButton) {
				timeline.closeSelected();
			}
		});

		let previousRow = null;

		// Journey hover
		qsa('.showresult-timeline').forEach((timelineElement) => {
			// On journey mouseenter
			timelineElement.addEventListener('mouseenter', (e) => {
				const targetRowBar = e.target.closest('.timeline-data-canvas-cells-rows-row-bar');
				if (targetRowBar && isDesktopView()) {
					e.stopPropagation();
					if (previousRow === targetRowBar || (js_params.device !== 'DESKTOP' && window.innerWidth < 700)) {
						return;
					}
					previousRow = targetRowBar;

					const flightElement = targetRowBar.closest('.timeline-data-canvas-cells-rows-row');
					const isMain = targetRowBar.closest('#main-timeline');
					const index = getNodeIndex(flightElement);
					const tripIndex = isMain ? 0 : 1;

					let flight = isMain ? timeline.resultData[index] : timeline.resultDataOther[index];
					if (flight) {
						let { left, top } = targetRowBar.getBoundingClientRect();
						const width = targetRowBar.clientWidth;

						left += width / 2;
						top += 30;
						top += window.scrollY;

						flight = { agents: [flight.agents[0]], trips: [flight.trips[tripIndex]] };

						let html = resultsRender.getRowHtml(flight, 0);

						html = html.replace('class="abResult', 'class="abResult abResult--timelinePopup');

						const popup = self.renderPopup({
							html: html,
							position: {
								left: left,
								top: top
							}
						});

						self.popup.push(popup);
					}
				}
			}, true); // Note: useCapture = true

			// if timer is set and mouse over, clear timer, return
			// if timer
			timelineElement.addEventListener('mouseleave', function (e) {
				const parent = e.target.closest('.timeline-data-canvas-cells-rows-row-bar');
				if (!parent || previousRow !== parent) {
					previousRow = null;
					self.removePopup();
				}
			}, true); // Note: useCapture = true
		});


		// We need the timeline canvas to scroll X...
		this.events = {
			canvas: {
				isMouseDown: false,
				scrollX: 0,
				scrollY: 0
			}
		};
		this.events.mousedown = (e) => {
			const elem = e.target;
			const scroller = elem.closest ? elem.closest('.timeline-data-canvas-scroller') : false;

			if (scroller) {
				this.events.canvas.scrollX = scroller.parentElement.scrollLeft + e.clientX;
				this.events.canvas.scrollY = window.scrollY + e.clientY;
				this.events.canvas.isMouseDown = true;
			}
		};
		this.events.mousemove = (e) => {
			const elem = e.target;
			const scroller = elem.closest ? elem.closest('.timeline-data-canvas-scroller') : false;

			if (scroller) {
				if (!this.events.canvas.isMouseDown) {
					return;
				}

				const scrollLeft = (this.events.canvas.scrollX - (e.clientX + scroller.parentElement.scrollLeft));
				scroller.parentElement.scrollLeft += scrollLeft;

				if (window.scrollBy) {
					const scrollTop = (this.events.canvas.scrollY - (e.clientY + window.scrollY));
					window.scrollBy(0, scrollTop);
				}
			}
		};
		this.events.mouseup = (e) => {
			const elem = e.target;
			const scroller = elem.closest ? elem.closest('.timeline-data-canvas-scroller') : false;

			if (scroller) {
				this.events.canvas.isMouseDown = false;
			}
		};
		document.addEventListener('mousedown', this.events.mousedown);
		document.addEventListener('mouseup', this.events.mouseup);
		document.addEventListener('mousemove', this.events.mousemove);
	},

	update () {
		if (!timeline.active) {
			return;
		}

		timeline.closeSelected();

		// Ask Showresult to update the results accordingly
		EventDispatcher.dispatch('updateResults', { params: { page: 0, groupBy: { index: 0 } }, source: 'timeline' });
	}
};

window.timeline = timeline;
